import React from 'react';
import styles from './Button.module.css';
import { string, func, bool, node } from 'prop-types';

const Button = ({ type, onClick, disabled, children }) => {
  const cls = [styles.button, styles[type]]

  return (
    <button
      onClick={onClick}
      className={cls.join(' ')}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  type: string,
  onClick: func,
  disabled: bool,
  children: node,
}

Button.defaultProps = {
  type: '',
  onClick: () => { },
  disabled: false,
  children: 'Default button',
}

export default Button